import { SectionHeading, WebsiteDemoLink } from './WebsitePrimitives';

/** Quote-led alternative to a public subscription/menu price table. */
export function MarketingQuoteSection({ id = 'pricing' }) {
  return <section id={id} className='tc-section tc-section--border'>
    <div className='tc-container tc-container--reading'>
      <SectionHeading eyebrow='Your shop, connected' heading='Let’s talk through <em>what your shop needs.</em>'>
        Bring your products, pricing rules, and order workflow. We’ll discuss the tools and setup help you need and provide a written quote covering your subscription, setup, and applicable platform fees.
      </SectionHeading>
      <div className='mt-6'><WebsiteDemoLink location={`${id}_quote`}>Book a demo</WebsiteDemoLink></div>
    </div>
  </section>;
}
